var modalWrap, modalContent;

window.addEventListener("click", function(event) {
    if (event.target == modalContent) {
        modalWrap.style.display = "none";
    }
});

function openPopupLogin() {
    modalWrap.style.display='table';
    showLoginScreen();
}

function showLoginScreen() {
    document.getElementById('loginContainer').style.display = 'block';
    document.getElementById('forgotContainer').style.display = 'none';
}

function showForgotScreen() {
    document.getElementById('loginContainer').style.display = 'none';
    document.getElementById('forgotContainer').style.display = 'block';
}

$(document).ready(function(){
    modalWrap = document.getElementById('modalLoginWrap');
    modalContent = document.getElementById('modalLoginContainer');
});